module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAAEhcmxxAAAAAXNSR0IArs4c6QAAAQtJREFUKBV1UTtuwkAQnTFLJAxV7hBhgqi4A30KkNKkjQRHSEMDN7AlJE4AQvS5Q0oi4Bx4iYPRsG9hF0eBLbxv3nuz8zGRO/U4FYvbEyk78nx7Jor1HFTQiPdvRLLyvmiStRAwPvDvjvsZk3wL8fOmH75QlOgtRJwoTocW2CDRmQ8uoDmVR8+hqm/BsAGUeqKXxLJFHSdaoVaq9EjogKI6/3n1zwAUC6Mhm2EdSi2cU0Se6E8HF8VkZHZA57wOSh1wZoGfqP/1zgfn8QkYQ5gUDGmuP2CoqnBkNyWUrwdh1yX9u9F4sfmiIfC/rsjewfCqW9p6UB3e4sEpZhpjerOah3sm8Mz8a9YwPgGZdHFUtEds6AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/export.png
// module id = Aj8F
// module chunks = 0